import React from 'react';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  elevated?: boolean;
  interactive?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

const paddingMap = {
  none: '',
  sm: 'p-4',
  md: 'p-5',
  lg: 'p-6',
};

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ children, elevated = false, interactive = false, padding = 'md', className = '', ...props }, ref) => {
    const classes = [
      'bg-white rounded-xl border border-slate-200',
      elevated ? 'shadow-md' : 'shadow-sm',
      interactive ? 'cursor-pointer hover:shadow-md hover:-translate-y-0.5 transition-all duration-150' : '',
      paddingMap[padding],
      className,
    ].filter(Boolean).join(' ');

    return (
      <div ref={ref} className={classes} {...props}>
        {children}
      </div>
    );
  }
);

Card.displayName = 'Card';
export default Card;
